import type { Moment } from 'moment';

export const validateTimeRange = (args: {
  isStartTime: boolean;
  startTime: Moment | undefined | null;
  endTime: Moment | undefined | null;
  errorMessage?: string;
}) => {
  const { isStartTime, startTime, endTime, errorMessage } = args;

  if ((isStartTime && !startTime) || (!isStartTime && !endTime)) {
    return Promise.reject('必填欄位');
  }
  if (startTime && endTime && endTime.isSameOrBefore(startTime, 'minute')) {
    return Promise.reject(errorMessage || '截止時間需晚於起始時間');
  }
  return Promise.resolve();
};
